export default class Ferias {
  constructor(
    id = 0,
    periodoAquisitivoId = 0,
    agendamentoAno = 0,
    periodo = 0,
    inicio = null,
    diasPendentes = 0,
    feriasPendentes = 0,
    situacao = 'PENDENTE',
    anoAgendamento = 0,
    mesAgendamento = 0,
    protocolo = '',
  ) {
    this.id = id;
    this.periodoAquisitivoId = periodoAquisitivoId;
    this.agendamentoAno = agendamentoAno;
    this.periodo = periodo;
    this.inicio = inicio;
    this.diasPendentes = diasPendentes;
    this.feriasPendentes = feriasPendentes;
    this.situacao = situacao;
    this.anoAgendamento = anoAgendamento;
    this.mesAgendamento = mesAgendamento;
    this.protocolo = protocolo;
  }
}



// WEBPACK FOOTER //
// ./src/domain/ferias/index.js